import { Role } from 'auth';
import { withPrivateAccess } from '@/modules/auth/hocs/withPrivateAccess.tsx';
import { CertificateBody } from '@/modules/issuer-dashboard/components/certificates/CertificateBody.tsx';
import { PageLayout } from 'ui';

const IssuerCertificates = () => {
  return (
    <PageLayout title="Certificates" contentClassName="px-0 py-2">
      <CertificateBody />
    </PageLayout>
  );
};

export default withPrivateAccess(IssuerCertificates, [Role.SR_ISSUER, Role.SR_ISSUER_ADMIN]);
